import Image from 'next/image'
import Marquee from 'react-fast-marquee'

const FurnitureMarquee: React.FC = () => {
  return (
    <Marquee autoFill>
      {Array.from({ length: 8 }).map((_, i) => (
        <Image
          key={i}
          src={`/assets/home/home-0${i + 1}.png`}
          alt=''
          width={300}
          height={300}
          className='mx-4 aspect-square h-[150px] w-[40vw] object-contain drop-shadow md:mx-8 md:h-[300px] md:w-auto'
        />
      ))}
    </Marquee>
  )
}

export default FurnitureMarquee
